<template>
    <div style="padding: 8px;">
        <div style="display: flex;align-items: center;">
            <div style="flex:1;">
                <el-tabs v-model="activeTab">
                    <el-tab-pane :label="$t('龙翼简报.日')" name="day"></el-tab-pane>
                    <el-tab-pane :label="$t('龙翼简报.月')" name="month"></el-tab-pane>
                </el-tabs>
            </div>
            <div>
                <el-date-picker size="mini" style="width: 150px;" v-show="activeTab == 'day'" v-model="queryDay"
                    type="date" :picker-options="datePickerOptions" :placeholder="$t('龙翼简报.选择日期')">
                </el-date-picker>
                <el-date-picker size="mini" style="width: 150px;" v-show="activeTab == 'month'" v-model="queryMonth"
                    type="month" :picker-options="monthPickerOptions" :placeholder="$t('龙翼简报.选择月份')">
                </el-date-picker>
            </div>
        </div>
        <el-divider></el-divider>
        <div v-if="activeTab == 'day'">
            <list chartId="div_chart_day" :beginDate="beginDate_day" :endDate="endDate_day" type="day" />
        </div>
        <div v-if="activeTab == 'month'">
            <list chartId="div_chart_month" :beginDate="beginDate_month" :endDate="endDate_month" type="month" />
        </div>
    </div>
</template>
<script>

import list from "./list"
export default {
    name: "dashboard",
    components: {
        list
    },
    data() {
        return {
            datePickerOptions: {
                disabledDate(date) {
                    return date > new Date(new Date().getTime())
                }
            },
            monthPickerOptions: {
                disabledDate(date) {
                    var t = new Date();
                    var n = new Date(t.getFullYear(), t.getMonth(), 1);

                    return date > new Date(n.getTime() - 24 * 60 * 60 * 1000)
                }
            },
            activeTab: "day",
            queryDay: "",
            queryMonth: "",
            beginDate_day: "",
            endDate_day: "",
            beginDate_month: "",
            endDate_month: "",
        }
    },
    watch: {
        queryDay() {
            var date = new Date();
            if (!(this.queryDay instanceof Date)) {
                date = new Date(this.queryDay);
            } else {
                date = this.queryDay;
            }
            var now = this.moment(date);
            this.beginDate_day = now.format('YYYY-MM-DD');
            // var next = now.add(1, 'days');
            this.endDate_day = now.format('YYYY-MM-DD');// next.format('YYYY-MM-DD');
        },
        queryMonth() {
            var date = new Date();
            if (!(this.queryMonth instanceof Date)) {
                date = new Date(this.queryMonth);
            } else {
                date = this.queryMonth;
            }
            var now = this.moment(date);
            this.beginDate_month = now.format('YYYY-MM-01');
            var next = now.add(1, 'months');
            next = this.moment(next.format('YYYY-MM-01')).subtract(1, 'days');
            this.endDate_month = next.format('YYYY-MM-DD');


        }
    },
    methods: {
    },
    mounted() {
        // console.log(this.moment('2018-08-08')) // 解析

        //  console.log(this.moment().format('{YYYY} MM-DDTHH:mm:ss SSS [Z] A')) // 展示


        // console.log( this.moment()
        //     .set('month', 3)
        //     .month() )// 获取

        // console.log( this.moment().add(1, 'year') )// 处理

        // console.log( this.moment().isBefore(this.moment())) // 查询
        // console.log( this.moment().subtract(0, 'days').format('YYYY-MM-DD')) // 查询
        // console.log( this.moment().subtract(1, 'months').format('YYYY-MM')) // 查询

        //初始化今天和上个月
        this.queryDay = this.moment().subtract(0, 'days').format('YYYY-MM-DD');
        this.queryMonth = this.moment().subtract(1, 'months').format('YYYY-MM');


    }
}
</script>
<style>
.el-divider--horizontal {
    margin-top: 0 !important;
}
</style>